import React from 'react';
import type { CreatorLookupStatus, SnapshotMetrics } from '@discovr/types';
import { MetricsCaptionText } from './MetricsCaptionText';
import type { ContentMetricsCopy } from './contentMetricsCopy';
import { resolveMetricsCaption, rowMetrics } from './creatorMetricsStatus';
import { useIsRechecking } from './profileRecheckStore';

interface EngagementRateCellProps {
  m: SnapshotMetrics;
  detailed?: boolean;
  lookup?: CreatorLookupStatus;
  /** Epoch ms from the caller's clock (useNow) — see AvgViewsCell. */
  now: number;
  /** The campaign platform's wording for the status caption. */
  copy: ContentMetricsCopy;
  /** Row identity for the metrics-recheck store subscription — see AvgViewsCell. */
  campaignId?: string;
  entryId?: string;
}

/** Eng. Rate: the value, or — for admins on an active profile — the metrics
 *  status caption. The ⟳ lives on Avg Views only; one job feeds both cells. */
export function EngagementRateCell({ m, detailed = false, lookup, now, copy, campaignId, entryId }: EngagementRateCellProps) {
  const settling = useIsRechecking(campaignId ?? '', entryId ?? '', 'metrics', rowMetrics(m));
  const rate = m.engagement_rate ?? 0;
  const caption = detailed ? resolveMetricsCaption(m, lookup, now, copy, settling) : null;
  if (rate > 0) {
    return (
      <span className="inline-flex flex-col items-end leading-tight">
        <span className="font-medium text-foreground">{`${rate.toFixed(2)}%`}</span>
        {caption?.kind === 'manual' && <MetricsCaptionText caption={caption} />}
      </span>
    );
  }
  if (caption && caption.kind !== 'manual') return <MetricsCaptionText caption={caption} />;
  return <span className="font-medium text-foreground">—</span>;
}
